module.exports = __webpack_public_path__ + "4955766d61915afe413d3f23729cc907.png";